import HomeScreenCard from "../HomeScreenCard";
import CardStatusBar from "../CardStatusBar";
import { AstroPrognosisStatus } from "./../../types/AstroPrognosisStatus";
import HomeCardTitle from "../HomeCardTitle";
import starsBackground from "@/assets/img/d_stars_background_1.png";
import planets from "@/assets/img/d_planets.png";

interface AstroPrognoseCardsProps {
  navigateToAstroPrognosis: () => void;
  astroPrognosisStatus: AstroPrognosisStatus | null;
  gridColumn: string;
  gridRow: string;
}

export const AstroPrognoseCards = ({
  navigateToAstroPrognosis,
  astroPrognosisStatus,
  gridColumn,
  gridRow,
}: AstroPrognoseCardsProps) => {
  return (
  <HomeScreenCard
    statusBar={
      <CardStatusBar
        text={astroPrognosisStatus?.timeToNextCard || "Доступно"}
        isAvailable={astroPrognosisStatus?.isAvailable || false}
      />
    }
    gridColumn={gridColumn}
    gridRow={gridRow}
    bgStyle={{
      background: `url(${starsBackground}) center/cover`,
    }}
    overlayImage={planets}
    overlayImageStyle={{
      top: "55%",
      left: "0%",
      width: "100%",
      height: "auto",
    }}
    onClick={() => navigateToAstroPrognosis()}
    style={{ cursor: "pointer" }}
  >
        <div
      className={`p-2 sm:p-3 md:p-4 flex flex-col h-full `}
      style={{ zIndex: 20, cursor: "pointer" }}
      onClick={() => navigateToAstroPrognosis()}
    >
      
      <HomeCardTitle isNeedShort={false} title="Астрологический прогноз на неделю" description="Общий астрологический гороскоп на предстоящую неделю" />
      <div className="h-full" style={{ zIndex: 30 }}></div>  
    </div>
    </HomeScreenCard>
  );
}






